import React, { createContext, useContext, useState } from "react";

const OnboardingDataContext = createContext(null);

export const useOnboardingData = () => {
  const context = useContext(OnboardingDataContext);
  if (!context) {
    throw new Error(
      "useOnboardingData must be used within an OnboardingDataProvider"
    );
  }
  return context;
};

export const OnboardingDataProvider = ({ children }) => {
  const [onboardingData, setOnboardingData] = useState(null);

  // Add navigation state
  const [navigationState, setNavigationState] = useState({
    isEditingFromStep5: false,
    editingScreen: null,
  });

  const updateOnboardingData = (data) => {
    setOnboardingData((prevData) => ({
      ...(prevData || {}),
      ...data,
    }));
  };

  const clearOnboardingData = () => {
    setOnboardingData(null);
  };

  const setEditMode = (screen) => {
    setNavigationState({
      isEditingFromStep5: true,
      editingScreen: screen,
    });
  };

  const clearEditMode = () => {
    setNavigationState({
      isEditingFromStep5: false,
      editingScreen: null,
    });
  };

  return (
    <OnboardingDataContext.Provider
      value={{
        onboardingData,
        updateOnboardingData,
        clearOnboardingData,
        navigationState,
        setEditMode,
        clearEditMode,
      }}
    >
      {children}
    </OnboardingDataContext.Provider>
  );
};
